import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Torre 1": { initFrame:  0 },
    "Torre 2": { initFrame:  0 },
    "Torre 3": { initFrame:  0 },
    "Torre 6": { initFrame:  0 },
    'Lobby de Acceso': { initFrame:  120 },
    'Salón Infantil': { initFrame:  0 },
    'Bicicleteros': { initFrame:  0 },
    'Gimnasio': { initFrame:  0 },
    'Salón Juvenil': { initFrame:  0 },
    'Salón Social': { initFrame:  0 },
    'BBQ': { initFrame:  0 },
    'Zona Comercial': { initFrame:  0 },
    'Zonas Húmedas': { initFrame:  0 },
    'Salón de Bienestar': { initFrame:  0 },
    'Salón de Yoga': { initFrame:  0 },
    'Sala de Entretenimiento': { initFrame:  0 },
    'Sala de Videojuegos': { initFrame:  0 },
    'Sala de Lectura de Niños': { initFrame:  0 },
    'Sala de Lectura de Adultos': { initFrame:  0 },
    'Salón de Piñatas': { initFrame:  0 },
    'Pet Park': { initFrame:  0 },
    'Lavandería': { initFrame:  0 },
    'Juegos Infantiles': { initFrame:  0 },
    'Coworking': { initFrame:  0 },

    //"EveryTransition": { importTransition: AllTransitions }
}
